import styled from "styled-components"
import ProTableOt from "./../../../utility/componentOt/views/ProtableOt"
import { useTranslation } from "react-i18next";
import { useBib } from "../../controllers/BibController";
import { Row, Col, Button, setParamsFilter, toast, Typography, DatePicker, message } from '../../../ui/ot'
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from 'react-router-dom'
import { useProTableOt } from '../../../utility/componentOt/controllers/ProtableOtController'
import { ArrowDownToLine } from 'lucide-react';

import dayjs from 'dayjs';
import { useCRUDController } from "../../../ui/classify_structure/CRUDController";
import { margin, padding } from "polished";
const ManageMARCRecord = ({
    title,
    keyPrefix = 'library.manage_marc_record'
}) => {
    const { t } = useTranslation('translation');
    const i18nPrefix = "library.manage_marc_record"
    return (<Row>
        <Col span={24}>
            <Title>
                {title || t(`${i18nPrefix}.manage_marc_record`)}
            </Title>
        </Col>
        <Col span={24}>
            <ManageMARCRecordTable title={title} keyPrefix={keyPrefix} selectType="checkbox" />
        </Col>
    </Row>)
}
const ManageMARCRecordTable = ({
    title,
    mode = "search",
    onSelectChange = () => { },
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    selectType = "radio",
    readonly
}) => {
    const thisJS = "ManageMARCRecord"
    const { t } = useTranslation('translation');
    const i18nPrefix = "library.manage_marc_record"
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectedRowsInfo)
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectedRowsKeys)
    const [search, setSearch] = useState({
        datecreated_start: dayjs().subtract(3, 'year').startOf('year').format('YYYY-MM-DD HH:mm:ss'),
        datecreated_end:  dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss'),
    })

    const navigate = useNavigate()
    const actionRef = useRef()
    const columns = [
        {
            title: t(`${i18nPrefix}.results`),
            dataIndex: 'bib_biblionumber',
            key: 'bib_biblionumber',
            sorter: true,
            width: '50rem',
            render: (text, record, index) => {
                return <Row>
                    {
                        getBibInfoFormat().map((value) => {
                            if (value?.language_name === "bib_title") {
                                return <Col span={24}>
                                    <Typography.P>{(index + 1)}.<Link to={`/library/backstage/BookDetail?bib_biblionumber=${record?.bib_biblionumber}`} style={{ color: 'blue', fontWeight: 'bold' }}>{value?.valueKeys.map((keysValue) => record?.[keysValue])}</Link></Typography.P>
                                </Col>
                            }
                            else if (value?.language_name === "Language") {
                                return <Col span={24}>
                                    <Typography.P>{t(`${i18nPrefix}.${value?.language_name}`)}：{value?.valueKeys.map((keysValue) => record?.[keysValue]?.['Language'])} </Typography.P>
                                </Col>
                            }
                            else {
                                return <Col span={24}>
                                    <Typography.P>{t(`${i18nPrefix}.${value?.language_name}`)}：{value?.valueKeys.map((keysValue) => {
                                        if (value?.isJoin) {
                                            return record?.[keysValue].join('、')
                                        }
                                        else {
                                            return record?.[keysValue]
                                        }
                                    })}</Typography.P>
                                </Col>
                            }

                        })
                    }
                    <Col span={24}>
                        <Row justify={'end'} gutter={[8, 8]}>
                            <Col>{record?.items_count > 0 ? t(`${i18nPrefix}.borrowed`) + "(" + (record?.items_borrowed_count || 0 )+ ")" : t(`${i18nPrefix}.No_items`)}</Col>
                            <Col>|</Col>
                            <Col>
                                <Link target="_blank" to={`/library/backstage/EditMARC?bib_biblionumber=${record?.bib_biblionumber}`}>{t('library.backstage.EditMARC.')}</Link>
                            </Col>
                            <Col>|</Col>
                            <Col>
                                <Button style={{
                                        border: "0px solid #5c9ded", 
                                        backgroundColor: "transparent", 
                                        color: "#000000", 
                                        padding: "5px",
                                        margin: "-10px 0px -10px 0px", 
                                        fontSize: "15px", 
                                    }}
                                    onClick={() => {
                                        console.log("start")
                                        BibController.deleteData([{biblionumber: record?.bib_biblionumber}])
                                        console.log("end")
                                    }}
                                >
                                    {t('library.backstage.DeleteMARC.')}
                                </Button>
                            </Col>
                            <Col>|</Col>
                            <Col>
                                <Link target="_blank" to={`/library/backstage/BookDetail?bib_biblionumber=${record?.bib_biblionumber}`}>{t('library.backstage.BookDetail.')}</Link>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            }
        },
        {
            title: t(`${i18nPrefix}.location`),
            dataIndex: 'items_count',
            key: 'items_count',
            align: "end",
            render: (text, record, index) => {
                if (!record.items_count) {
                    return <>
                        {t(`${i18nPrefix}.No_items`)}
                    </>
                } else {
                    return <>
                        <Typography.P>{record?.items_count}{t(`${i18nPrefix}.item`)}, {record?.items_count - record?.items_borrowed_count}{t(`${i18nPrefix}.available`)}</Typography.P>
                    </>
                }
            }
        },
    ]
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.task_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.task_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                select_temp.push(record.task_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.task_id)
                selectRow = selectRow.filter(row => row.task_id !== record.task_id)
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };

    const {
        getBibData,
        getBibInfoFormat
    } = useBib({
        onFinish: ({ axiosMode, status, values }) => {
            console.log(thisJS, "getBibData OnFinish", axiosMode, status, values)
            if (axiosMode === "delete") {
                if (status === "success") {
                    toast.success(t("delete") + " " + t("success"))
                }
                else {
                    toast.error(t("delete") + " " + t("failed"))
                }
                actionRef.current.reload()
            }
        },
        onBefore: () => { }
    })
    const BibController = useCRUDController({ 
        apiRoute: "/koha/bib", 
        onFinish: ({ axiosMode, status, values }) => {
            console.log(thisJS, "deleteBibData OnFinish", axiosMode, status, values)
            if (axiosMode === "delete") {
                if (status === "success") {
                    message.success(t("delete") + " " + t("success"))
                }
                else {
                    message.error(t("delete") + " " + t("failed"))
                }
                actionRef.current.reload()
            }
        },
        onBefore: () => { }
    })
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn
    } = useProTableOt({
        columns
    })
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])
    return (
        <Row>

            <Col span={24}>
                <ProTableOt
                    searchParams={search}
                    actionRef={actionRef}
                    columns={columns}
                    request={async (params = {}, sort, filter) => {
                        // setAxiosMode("get")
                        let newParams = {
                        };
                        let order = setOrders(sort)
                        newParams = {
                            // ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            // custom_filter_value: params.keyword ?? "",
                            keyword: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                            "field": !!params.keyword ? "keyword" : "",

                            ...search,
                            // "categorycode": "TEST",
                            // search:[
                            //     {field: "title", keyword: "魔法石"},
                            //     {field: "author", keyword: "JK"}
                            // ]
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });
                        // setPageSize(params?.pageSize ?? 20)
                        return getBibData({
                            ...newParams
                        })
                    }}
                    scroll={{
                        x: "100%",
                        y:  undefined,
                    }}
                    toolBarRender={() => {
                        return ([
                            <Col span={24}>
                                <Row gutter={[4, 4]} align={"middle"}>
                                    <Col>
                                        <Typography.P>
                                            {t(`${i18nPrefix}.import_bibliography_date`)}:
                                        </Typography.P>
                                    </Col>
                                    <Col>
                                        <DatePicker.Time
                                            placeholder={t(`${i18nPrefix}.time_start`)}
                                            format={"YYYY-MM-DD"}
                                            value={search?.datecreated_start ? search?.datecreated_start : undefined}
                                            onChange={(e) => {
                                                setSearch((pre) => {
                                                    if (dayjs(e.target.value).isBefore(dayjs(pre?.datecreated_end, "YYYY-MM-DD"))) {
                                                        return {
                                                            ...pre,
                                                            datecreated_start: dayjs(e.target.value).format("YYYY-MM-DD"),
                                                        }
                                                    }
                                                    else {
                                                        return {
                                                            ...pre,
                                                            datecreated_start: pre?.datecreated_end,
                                                            datecreated_end: e.target.value,
                                                        }
                                                    }

                                                })
                                            }}
                                        />
                                    </Col>
                                    <Col>
                                        <Typography.Title level={4}>
                                            ~
                                        </Typography.Title>
                                    </Col>
                                    <Col>
                                        <DatePicker.Time
                                            placeholder={t(`${i18nPrefix}.time_end`)}
                                            format={"YYYY-MM-DD"}
                                            value={search?.datecreated_end ? search?.datecreated_end : undefined}
                                            onChange={(e) => {
                                                setSearch((pre) => {
                                                    if ((dayjs(e.target.value)).isBefore(pre?.datecreated_start)) {
                                                        return {
                                                            ...pre,
                                                            datecreated_start: e.target.value,
                                                            datecreated_end: pre?.datecreated_start,
                                                        }
                                                    }
                                                    else {
                                                        return {
                                                            ...pre,
                                                            datecreated_end: e.target.value,
                                                        }
                                                    }

                                                })
                                            }}
                                        />
                                    </Col>
                                    {(search.time_start || search.time_end) &&
                                        <Col>
                                            <Button
                                                type={"icon"}
                                                onClick={() => {
                                                    setSearch((pre) => {
                                                        return {
                                                            datecreated_start: undefined,
                                                            datecreated_end: undefined
                                                        }
                                                    })
                                                }}>
                                                X
                                            </Button>
                                        </Col>
                                    }
                                </Row>
                            </Col>,
                            <Button variant="outline" onClick={() => { window.open("/library/backstage/AddMARC", "_blank") }}>
                                {t('library.backstage.AddMARC.')}
                            </Button>,
                            <Button variant="outline" onClick={() => { window.open("/library/backstage/SearchZ3950", "_blank") }}>
                                {t('library.backstage.SearchZ3950.')}
                            </Button>,
                            //    ( !readonly &&
                            //     <Button
                            //         className='example'
                            //         style={{ background: '#1565C0', color: '#ffffff' }}
                            //         onClick={e => BibController.exportData({ 'staff_id_arr': selectedRowKeys })}
                            //     >
                            //         匯出資料 <ArrowDownToLine size={16} />
                            //     </Button>),

                        ])
                    }}
                    rowSelection={{
                        type: selectType,
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: setSelectedRowsInfo,
                        ...rowSelection,
                    }}
                />
            </Col>
        </Row>
    )
}


const Title = styled.div`
text-align: left;
width: 100%;
font-size: 1.6em;
font-weight: 600;
`


export default ManageMARCRecord
export { ManageMARCRecordTable }
